/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'pip-model',
    'pip-events',
    'Localizer',
    'cookie-utils'
],
function(
    $,
    pip,
    pipEvents,
    Localizer,
    cookieUtils
){

	//DO NOT ADD ANYTHING TO THIS MODULE!!!!!
	//USE THE DDO_analytics MODULE AT THE END OF THIS FILE - MERGING THESE TOGETHER WHILE WE PHASE OUT _hddata
	var status;
	var userId;

    var _hddata = new Object();

	function getUserIdFromUserActivityCookie() {
		var startsWithName = "WC_USERACTIVITY_";

		// GLOBAL -- use cookie-utils
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = (ca[i]);
			if (c.indexOf(startsWithName) != -1) {
				return c.substring(c.lastIndexOf('_') + 1, c.indexOf('='));
			}
		}
		return "";
	}

	function readUserStatusCookie() {
		var wcPersistent = cookieUtils.readBrowserCookie('WC_PERSISTENT');
		var wcUserActivity = getUserIdFromUserActivityCookie();

		if (cookieUtils.readCookie("THD_USERSTATUS") == "1") {
			status = "authenticated";
			userId = wcUserActivity;
		}
		else if (cookieUtils.readCookie("THD_REMEMBERME") && cookieUtils.readCookie("THD_USERSTATUS") != "1") {
			status = "recognized";
			userId = wcUserActivity;
		} else if (wcUserActivity == -1002) {
			status = "anonymous";
			userId = "-1002";
		} else {
			status = "guest";
			userId = wcUserActivity;
		}
	}





		var analytics = {};

		analytics.send = function send(type){
			if(window.hddataReady) window.hddataReady(type);
			ishddataReady = true;
		};

		analytics.init = function init(){

            if(!pip.products.primary.data) return;

            readUserStatusCookie();

            _hddata["custStatus"] = status;
            _hddata["customerID"] = userId;
            _hddata["productView"] = "productView";
            _hddata["pageType"] = "PIP";
            _hddata["abTest"] = "";
            _hddata["pageName"] = "productDetails>" + pip.products.primary.data.itemId;

            if (Localizer.status.isLocalized()) {
                _hddata["localStoreNum"] = Localizer.getLocalizedStore().storeId;
                _hddata["localState"] = Localizer.getLocalizedStore().storeId;
                _hddata["localZipCode"] = Localizer.getLocalizedStore().zipcode;
            }

            _hddata["productID1"] = pip.products.primary.data.itemId;
            _hddata["productType1"] = pip.products.primary.data.itemType;
            var experienceType = cookieUtils.readCookie('THD_USERTYPE');
            if (experienceType == 'P') {
                _hddata["experienceType"] = "pro";
            } else {
                _hddata["experienceType"] = "consumer";
            }
            var hddcCookieValue = cookieUtils.readCookie("HD_DC");
            if (hddcCookieValue != undefined) {
                if (hddcCookieValue == 'beta') {
                    _hddata["betaSite"] = 'beta';
                } else if (hddcCookieValue == 'origin') {
                    _hddata["betaSite"] = 'prod';
                }
            }

            _hddata.map = {"Hierarchy": false, "buybox": false};

            window._hddata = _hddata;

			analytics.strikeThroughPricing();
			analytics.mapPricing();
            analytics.alphaPrompt();

            _hddata.map["buybox"] = true;
            if (window.hddataReady) {
                window.hddataReady();
            }

            if(pip.debugMode) {
                console.log("_hddata", _hddata);
            }
		};

		analytics.strikeThroughPricing = function strikeThroughPricing(){
			if(pip.products.primary.data.info.isAppliance){
				var strikeThrough = 'no strike through';
				if($('.pricingStrikeThru:visible').length == 1){
					strikeThrough = 'strike through';
				} else if($('.pricingStrikeThru').length > 1){
					strikeThrough = 'multiple strike through';
				}
				_hddata['priceType1'] = 'Price displayed: ' + strikeThrough;
			}
		};

		analytics.mapPricing = function mapPricing(){
			if($('#mapContainer').length){
				if($('#mapStrikeThru').length){
					_hddata["priceType1"] = "Price displayed: MAP strike through";
				} else {
					_hddata["priceType1"] = "Price not displayed: MAP no strike through";
				}
			}
		};

		// TODO
		// This is an existing error message re-used for alpha prompt also. This will be moved to DDO when we remove the
		// inline scripts tag from buybox-pickupinstore.mustache.html
		analytics.alphaPrompt = function alphaPrompt() {
			if (pip.products.primary.data.storeSkus[0] && pip.products.primary.data.storeSkus[0].fulfillmentOptions) {
				var fmOptions = pip.products.primary.data.storeSkus[0].fulfillmentOptions;
				if (fmOptions.buyOnlinePickupInStore && fmOptions.buyOnlinePickupInStore.alphaPromptRestriction == 'SUPPRESS'
					|| fmOptions.deliverFromStore && fmOptions.deliverFromStore.alphaPromptRestriction == 'SUPPRESS') {
					_hddata["errorMessage"] = "AlphaPrompt: At this location, the item must be purchased in-store";
				}
			}
		};

		pipEvents.threeSixty.threeSixtyLoadingStart.off('.threeSixtyLoadingStart-analyticsHDdata');
		pipEvents.threeSixty.threeSixtyLoadingStart.on('.threeSixtyLoadingStart-analyticsHDdata', function(){
			analytics.send('Threesixty images requested by user');
		});

		pipEvents.threeSixty.threeSixtyJSONRequestError.off('.threeSixtyJSONRequestError-analyticsHDdata');
		pipEvents.threeSixty.threeSixtyJSONRequestError.on('.threeSixtyJSONRequestError-analyticsHDdata', function(){
			_hddata.errorMessage = 'Threesixty JSON request error';
			analytics.send('formError');
		});

		pipEvents.threeSixty.threeSixtyTimeoutThresholdReached.off('.threeSixtyTimeoutThresholdReached-analyticsHDdata');
		pipEvents.threeSixty.threeSixtyTimeoutThresholdReached.on('.threeSixtyTimeoutThresholdReached-analyticsHDdata', function(){
			_hddata.errorMessage = 'Threesixty image loading timeout error';
			analytics.send('formError');
		});

		pipEvents.threeSixty.threeSixtyThumbnailFailedToLoad.off('.threeSixtyThumbnailFailedToLoad-analyticsHDdata');
		pipEvents.threeSixty.threeSixtyThumbnailFailedToLoad.on('.threeSixtyThumbnailFailedToLoad-analyticsHDdata', function(){
			_hddata.errorMessage = 'Threesixty thumbnail did not load';
			analytics.send('formError');
		});

		analytics.getThrottleVersionFromCookie = function getThrottleVersionFromCookie(){
			var THD_PERSIST = cookieUtils.readCookie('THD_PERSIST');
			if(THD_PERSIST){
				var featureThrottle = cookieUtils.readCookie('FEATURE_THROTTLE');
				if(featureThrottle){
					var crumbs = featureThrottle.split('-');
					var throttleVal = $.grep(crumbs, function(value) {
					    return value.indexOf('18') !== -1;
					});
					if(throttleVal.length){
						return throttleVal[0].split('.')[1] == 1 ? 'v3' : 'v2';
					}
				}
			}
			return '';
		}


		// TODO: Remove digitalData.  Clients can call the methods below directly against our analytics module.
		analytics.digitalData = {

			pushEvent: function pushEvent(data) {
				window.digitalData.event.push(data);
			},

			processPageLoadEvent: function processPageLoadEvent(page, productArray) {
				if (!window.digitalData
						|| !window.digitalData.pageDataReady
						|| !this.isValidPageObject(page)) {
					return;
				}

				if (!window.digitalData.page) {
					window.digitalData.page = page;
				} else if (!window.digitalData.page.pageInfo) {
					window.digitalData.page.pageInfo = page.pageInfo;
				} else {
					window.digitalData.page.pageInfo.pageLoadEvent =
							page.pageInfo.pageLoadEvent;
				}

				if (productArray && productArray.length > 0) {
					window.digitalData.product = productArray;
				}

				window.digitalData.pageDataReady();
				window.digitalData.isReady = true;
			},

			isValidPageObject: function isValidPageObject(page) {
				if (!page
						|| !page.pageInfo
						|| !page.pageInfo.pageLoadEvent) {
					return false;
				}
				return true;
			}
		};

	return analytics;

});

}.call(window));